import React from 'react';
import './recordList.scss';

function RecordList(props) {
  return (
    <div className='recordList'>
      <table>
        <tbody>
          <tr>
            <th>订单号</th>
            <th>券号</th>
            <th>核销时间</th>
          </tr>
          {
            props.records.map((item,index) => {
              return <tr key={index}>
                <td>{item.orderCode}</td>
                <td>{item.grouponCode}{
                  item.sourceId === '5' &&
                  <i><img alt='' src={require('assets/images/icon-info-grey.png')} onClick={() => {props.handleTip()}}/></i>
                  }
                </td>
                <td>{item.verifyTime}</td>
              </tr>
            })
          }
        </tbody>
      </table>
    </div>
  );
}
export default RecordList;
